import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { BatchEventsManager } from "@faire/web--source/common/batch-events/BatchEventsManager";
import { forceReload } from "@faire/web--source/common/forceReload";
import { getDocument } from "@faire/web--source/common/globals/getDocument";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { trackFrontendApisReleaseReloaded } from "@faire/web-api--source/events/frontendApis/actionUnknown/releaseReloaded";
var MAXIMUM_SESSION_LENGTH_HOURS = 168;
var checkForExpiredSession = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function() {
        var numHours, MAXIMUM_SESSION_LENGTH_MILLISECONDS;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    numHours = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : MAXIMUM_SESSION_LENGTH_HOURS;
                    MAXIMUM_SESSION_LENGTH_MILLISECONDS = numHours * 60 * 60 * 1000;
                    if (!(new Date().getTime() - websiteLoadTime > MAXIMUM_SESSION_LENGTH_MILLISECONDS)) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    trackFrontendApisReleaseReloaded();
                    return [
                        4,
                        BatchEventsManager.get().flush()
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    forceReload();
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function checkForExpiredSession() {
        return _ref.apply(this, arguments);
    };
}();
var websiteLoadTime = new Date().getTime();
// Default is 7 days
export var reloadExpiredSessions = function() {
    var numHours = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : MAXIMUM_SESSION_LENGTH_HOURS;
    var // Mobile does not fire a visibility changed event when loading an app for the first time,
    // so we need to fire an event on focus
    _getWindow, // Mobile browsers only fire a focus event when the app is closed. Since we would like to fire
    // events whenever people return to the tab or switch to the app, we need to listen for visibility changes
    _getDocument, // In rare cases, a session may stay hidden for a long time and won't trigger the visibility change event
    // nor the focus event, so we need a general timout check to force reload the page after numHours hours. Otherwise,
    // the stale session may stay alive and keep sending API requests with outdated parameters or data.
    _getWindow1;
    (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.addEventListener("focus", function() {
        return checkForExpiredSession(numHours);
    });
    (_getDocument = getDocument()) === null || _getDocument === void 0 ? void 0 : _getDocument.addEventListener("visibilitychange", function() {
        return checkForExpiredSession(numHours);
    });
    (_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : _getWindow1.setTimeout(function() {
        checkForExpiredSession(numHours);
    }, numHours * 60 * 60 * 1000);
};
